"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _useMulticurrencyToPrice = _interopRequireDefault(require("@sprinx/react-globalize/useMulticurrencyToPrice"));

var _useShoppingCurrency = _interopRequireDefault(require("../../shop/useShoppingCurrency"));

var _AppSettingsProvider = require("../../app/AppSettingsProvider/AppSettingsProvider");

var _mapStockDetail = _interopRequireDefault(require("./mapStockDetail"));

var getBrand = function getBrand(product) {
  return product.manufacturer && product.manufacturer.name ? {
    brand: {
      '@type': 'Brand',
      name: product.manufacturer.name
    }
  } : {};
};

var getOffer = function getOffer(product, currency, getPrice, siteRoot) {
  var availability = product && product.stockQuantity && (0, _mapStockDetail.default)(product.stockQuantity.detail || []);
  var price = Boolean(product.salePriceWithTax) && getPrice(product.salePriceWithTax);
  return availability && price && price > 0 ? {
    offers: {
      '@type': 'Offer',
      price: price,
      priceCurrency: (currency || []).split('-')[0],
      availability: availability,
      url: "".concat(siteRoot).concat(product.href)
    }
  } : {};
};

var getProductData = function getProductData(product, currency, getPrice, siteRoot, t) {
  return (0, _extends2.default)({
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: t(product.name),
    image: Array.isArray(product.image) && (product.image.find(function (_ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 1),
          format = _ref2[0];

      return format === 'original';
    }) || [])[1] || '',
    description: product.description ? t(product.description) : '',
    sku: product.sku,
    gtin13: product.ean
  }, getBrand(product), getOffer(product, currency, getPrice, siteRoot));
};

var _ref4 = /*#__PURE__*/_react.default.createElement("meta", {
  property: "og:type",
  content: "product"
});

function StructuredDataProduct(_ref3) {
  var product = _ref3.product;
  var siteRoot = (0, _AppSettingsProvider.useAppSettingsSiteRoot)();
  var t = (0, _useTranslate.default)();
  var currency = (0, _useShoppingCurrency.default)();
  var getPrice = (0, _useMulticurrencyToPrice.default)(null, currency);
  return product ? /*#__PURE__*/_react.default.createElement(_reactHelmet.default, null, /*#__PURE__*/_react.default.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(getProductData(product, currency, getPrice, siteRoot, t))), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:url" // eslint-disable-next-line react/prop-types
    ,
    content: siteRoot + product.href
  }), _ref4, /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:title",
    content: t(product.name)
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:description",
    content: product.description ? t(product.description) : ''
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:image",
    content: // eslint-disable-next-line react/prop-types
    Array.isArray(product.image) && (product.image.find(function (_ref5) {
      var _ref6 = (0, _slicedToArray2.default)(_ref5, 1),
          format = _ref6[0];

      return format === 'original';
    }) || [])[1] || ''
  })) : null;
}

process.env.NODE_ENV !== "production" ? StructuredDataProduct.propTypes = {
  product: _propTypes.default.shape({
    description: _propTypes.default.arrayOf(_propTypes.default.shape({
      language: _propTypes.default.string,
      text: _propTypes.default.string
    })).isRequired,
    ean: _propTypes.default.string.isRequired,
    name: _propTypes.default.arrayOf(_propTypes.default.shape({
      language: _propTypes.default.string,
      text: _propTypes.default.string
    })).isRequired,
    sku: _propTypes.default.string.isRequired
  })
} : void 0;
StructuredDataProduct.defaultProps = {
  product: undefined
};
var _default = StructuredDataProduct;
exports.default = _default;